<template>
  <div>
    <div class="row-info">
      <div class="row-info-title">
        产品信息
        <span class="edit-icon-div" v-if="this.infoData.publish_status == '未发布'"
          ><img
            class="width-full"
            src="../../assets/img/buttonedit.svg"
            alt=""
            @click="showUpdataProductModel"
        /></span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">产品名称：</span>
        <span class="row-info-contant-contant">{{ infoData.product_name }}</span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">创建时间：</span>
        <span class="row-info-contant-contant">{{ infoData.created_at_str }}</span>
      </div>
      <!-- <div class="row-info-contant">
        <span class="row-info-contant-title">数据校验级别</span>
        <span class="row-info-contant-contant">{{ infoData.check_level }}</span>
      </div> -->
      <div class="row-info-contant">
        <span class="row-info-contant-title">产品KEY：</span>
        <span class="row-info-contant-contant">{{ infoData.product_key }}</span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">认证方式：</span>
        <span class="row-info-contant-contant">{{ infoData.auth_style }}</span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">产品类型：</span>
        <span class="row-info-contant-contant">{{ infoData.product_type }}</span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">连接类型：</span>
        <span class="row-info-contant-contant">{{ infoData.link_type }}</span>
      </div>
      <div class="row-info-contant">
        <span class="row-info-contant-title">状态：</span>
        <span class="row-info-contant-contant">{{infoData.publish_status}}</span>
      </div>
      <div class="row-info-contant" v-if="infoData.sub_product">
        <span class="row-info-contant-title">子设备默认产品：</span>
        <span class="row-info-contant-contant">{{ infoData.sub_product }}</span>
      </div>
    </div>

    <UpdataProduct
      :showInputDialog.sync="UpdataProductloading"
      :infoData="updataData"
      @getData="getData"
      ref="UpdataProduct"
    ></UpdataProduct>
  </div>
</template>

<script>
import UpdataProduct from "@/components/product/updata-product.vue";
import { copy } from "@/common/libs/utils";
import { AUTH_STYLE, LINKTYPE } from "@/common/libs/Contains";

export default {
  components: { UpdataProduct },
  props: {
    productName: {},
    productId: {},
    productKey: {},
  },
  data() {
    return {
      UpdataProductloading: false,
      infoData: {},
      updataData: {},
      status:1,
      PRODUCTTYPE: {}
    };
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      this.$getData("/td/td-iot-api/iot/product/types/v1", false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          res.data.map((item) =>{
            let key = item.type
            this.PRODUCTTYPE[key] = item.name
          })
        }else {
          this.$message.error(res.msg);
        }
        this.getData()
      });
    },
    async getData() {
      const subData = {
        id: this.productId,
      };
      const res = await this.$getData("/td/td-iot-api/iot/product/v1", subData);
      if (res.code === 0) {
        this.$emit('changStatus', res.data.publish_status)
        this.status = res.data.publish_status
        this.infoData = copy(res.data);
        this.infoData.product_type = this.PRODUCTTYPE[this.infoData.product_type]
        // this.infoData.check_level = CHECHLEVEL[this.infoData.check_level]
        this.infoData.auth_style = AUTH_STYLE[this.infoData.auth_style]
        this.infoData.link_type = LINKTYPE[this.infoData.link_type]
        this.infoData.publish_status = this.infoData.publish_status === 1 ? '已发布' : '未发布'
        this.updataData = copy(res.data);
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    showUpdataProductModel() {
      this.UpdataProductloading = !this.UpdataProductloading;
    },
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss">
</style>
